import PropTypes from 'prop-types';
import React from 'react';
import Help from '../Help';
import Label from '../Label';
import LabelWithTag from '../LabelWithTag';
import ValidationIcon from '../ValidationIcon';
import {ErrorMessage, InfoMessage} from '../ErrorMessage';
import InputWrapper from '../InputWrapper';
import defaultProps from '../common-default-props';
import propTypes, {tagValues} from '../common-prop-types';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface SharedFormControlProps {
  children: any;
  label: string;
  className?: string;
  disabled?: boolean;
  info?: string;
  error?: string;
  help?: any;
  id?: string;
  name?: string;
  valid?: boolean;
  validated?: boolean;
  isCompact?: boolean;

  blur?: any;
  change?: any;
  filter?: any;
  focus?: any;
  initialise?: any;
  validate?: any;

  active?: any;
  filtered?: any;
  filtering?: any;
  initialised?: any;
  lastValidValue?: any;
  validating?: any;
  tag?: tagValues;

  [key: string]: unknown;
}

export interface FormControlProps extends SharedFormControlProps {
  width?: string | number;
  isEmptyAndOptional?: boolean;
}

const FormControl: React.FC<FormControlProps> = ({
  children,
  className,
  disabled,
  error,
  info,
  help,
  id,
  label,
  name,
  valid,
  validated,
  isCompact,
  width,
  isEmptyAndOptional,
  tag,

  /* eslint-disable @typescript-eslint/no-unused-vars */
  //redux-formo methods
  blur,
  change,
  filter,
  focus,
  initialise,
  validate,

  //redux-form props
  active,
  filtered,
  filtering,
  initialised,
  validating,
  lastValidValue,
  /* eslint-enable @typescript-eslint/no-unused-vars */
  ...otherProps
}) => {
  const isSelectInput = children && children.type.displayName === 'Select';

  return (
    <div className={className}>
      <Label htmlFor={id} isCompact={isCompact} disabled={disabled}>
        {tag ? <LabelWithTag label={label} tag={tag} /> : label}
      </Label>

      {help ? (
        React.isValidElement(help) ? (
          <div id={`help-${id}`}>{help}</div>
        ) : (
          <Help id={`help-${id}`} disabled={disabled}>
            {help}
          </Help>
        )
      ) : null}

      <InputWrapper isSelectInput={isSelectInput} width={width} isCompact={isCompact}>
        {children && React.cloneElement(children, {...otherProps, name, disabled, valid, validated, id, 'aria-describedby': `help-${id} error-${id}`, 'aria-invalid': !valid, isCompact})}
        {((validated && !valid) || (validated && !isEmptyAndOptional)) && <ValidationIcon valid={valid} outside={isSelectInput} isCompact={isCompact} disabled={disabled} />}
      </InputWrapper>

      {validated && error && <ErrorMessage valid={valid} id={`error-${id}`} error={error} disabled={disabled} />}
      {validated && info && <InfoMessage valid={valid} id={`info-${id}`} info={info} disabled={disabled} />}
    </div>
  );
};

FormControl.propTypes = {
  ...propTypes,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isEmptyAndOptional: PropTypes.bool
};

FormControl.defaultProps = {
  ...defaultProps,
  isEmptyAndOptional: false
};

export default FormControl;
